import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';
import { Injectable } from '@angular/core';
import { AuthorizerService } from '@markant-platform/authorizer/data-access';

@Injectable({
  providedIn: 'root',
})
export class GroupAssignmentDetailResolver {
  constructor(private authorizerService: AuthorizerService) {}

  async resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Promise<Observable<Breadcrumb[]>> {
    const groupId = route.params['groupId'];

    return this.authorizerService.getGroupById(groupId).pipe(
      map(group => [
        {
          label: group.displayName,
          url: `group-assignment/${groupId}`,
        },
      ])
    );
  }
}
